/**
 * Feature Flags
 * 
 * Centralized feature flag management for controlling
 * feature visibility across environments.
 * 
 * Usage:
 *   import { isDevMode } from "@/lib/featureFlags";
 *   if (isDevMode) { ... }
 */

/**
 * Local override for testing purposes.
 * Set to `true` to force dev mode even in production.
 * WARNING: Never commit this as `true` to production!
 */
const LOCAL_DEV_OVERRIDE = false;

/**
 * Determines if the application is running in development mode.
 * 
 * Returns true when:
 * - NODE_ENV is not "production"
 * - OR LOCAL_DEV_OVERRIDE is explicitly set to true
 * 
 * Dev-only features should check this flag before rendering.
 */
export const isDevMode: boolean = 
  import.meta.env.MODE !== "production" || LOCAL_DEV_OVERRIDE;

/**
 * Feature flag definitions
 * Add new feature flags here as the app grows.
 */
export const featureFlags = {
  /** Show developer tools panel in dashboard */
  showDevTools: isDevMode,
  
  /** Enable allocation logging (always on for observability) */
  enableAllocationLogs: true,
  
  /** Show debug information in console */
  verboseLogging: isDevMode,
} as const;

export default featureFlags;
